import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {
  SalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/salary-dividend.options';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import { CompanyTypeEnum } from '../../../../../../../../../../../common/src/enums/company-type.enum';
import {
  SalaryContributionsOptionsInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/salary-contributions/salary-contributions-options-in-salary-dividend.options';
import {
  CorporateIncomeTaxConnectedCorporationOptions,
} from '../../../../../../../../../../../common/src/options/calculations/income-tax/corporate/common/corporate-income-tax-connected-corporation.options';
import {
  CorporateIncomeTaxInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/corporate/corporate-income-tax-in-salary-dividend.options';
import {
  CorporateIncomeTaxQuebecInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/corporate/corporate-income-tax-quebec-in-salary-dividend.options';
import {
  CorporateIncomeTaxFederalInSalaryDividendOptions,
} from '../../../../../../../../../../../common/src/options/calculations/salary-dividend/income-tax/corporate/corporate-income-tax-federal-in-salary-dividend.options';


@Component({
  selector: 'app-salary-dividend-corporate-tax-form',
  templateUrl: './salary-dividend-corporate-tax-form.component.html',
  styleUrls: ['./salary-dividend-corporate-tax-form.component.scss'],
  standalone: false,
})
export class SalaryDividendCorporateTaxFormComponent {

  @Input()
  form: AdvancedForm<SalaryDividendOptions>;

  @Input()
  corporateIncomeTaxOptionsForm: AdvancedFormGroup<CorporateIncomeTaxInSalaryDividendOptions>;

  CompanyType = CompanyTypeEnum;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get connectedCorporations(): AdvancedFormArray<CorporateIncomeTaxConnectedCorporationOptions> {
    return this.corporateIncomeTaxOptionsForm.formElements.connectedCorporations as AdvancedFormArray<CorporateIncomeTaxConnectedCorporationOptions>;
  }

  get corporateIncomeTaxQuebecForm(): AdvancedFormGroup<CorporateIncomeTaxQuebecInSalaryDividendOptions> {
    return this.corporateIncomeTaxOptionsForm.formElements.incomeTaxCorporationQuebec as AdvancedFormGroup<CorporateIncomeTaxQuebecInSalaryDividendOptions>;
  }

  get corporateIncomeTaxFederalForm(): AdvancedFormGroup<CorporateIncomeTaxFederalInSalaryDividendOptions> {
    return this.corporateIncomeTaxOptionsForm.formElements.incomeTaxCorporationFederal as AdvancedFormGroup<CorporateIncomeTaxFederalInSalaryDividendOptions>;
  }

  get salaryContributionsForm(): AdvancedFormGroup<SalaryContributionsOptionsInSalaryDividendOptions> {
    return this.form.formElements.salaryContributionsOptions as AdvancedFormGroup<SalaryContributionsOptionsInSalaryDividendOptions>;
  }

  refresh() {
  }
}
